export const TENANT_RESET_STATE = 'TENANT_RESET_STATE';
export const TENANT_CURRENT_ITEM = 'TENANT_CURRENT_ITEM';

export const TENANT_REQUEST_LOADING = 'TENANT_REQUEST_LOADING';
export const TENANT_REQUEST_SUCCESS = 'TENANT_REQUEST_SUCCESS';
export const TENANT_REQUEST_FAILED = 'TENANT_REQUEST_FAILED';

export const TENANT_CURRENT_ACTION = 'TENANT_CURRENT_ACTION';
export const TENANT_RESET_ACTION = 'TENANT_RESET_ACTION';